"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlyoutWindow = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useOutsideMouseEvent = require("b2b-components/hooks/useOutsideMouseEvent");
var _classnames = _interopRequireDefault(require("classnames"));
require("./FlyoutWindow.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var FlyoutWindow = function FlyoutWindow(_ref) {
  var closeFlyoutWindow = _ref.closeFlyoutWindow,
    renderContent = _ref.renderContent,
    togglerRef = _ref.togglerRef,
    className = _ref.className;
  var wrapperRef = (0, _react.useRef)(null);
  var setWrapperRef = function setWrapperRef(element) {
    return wrapperRef.current = element;
  };
  (0, _useOutsideMouseEvent.useOutsideMouseEvent)('click', [wrapperRef, togglerRef], function () {
    closeFlyoutWindow();
  }, {
    options: {
      capture: true
    }
  });
  (0, _react.useEffect)(function () {
    var handleEscape = function handleEscape(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        closeFlyoutWindow();
      }
    };
    document.addEventListener('keydown', handleEscape, false);
    return function () {
      return document.removeEventListener('keydown', handleEscape, false);
    };
  }, [closeFlyoutWindow]);
  var rootClassName = (0, _classnames["default"])('cds-FlyoutWindow', className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-FlyoutWindow-Body",
    ref: setWrapperRef
  }, renderContent(closeFlyoutWindow))));
};
exports.FlyoutWindow = FlyoutWindow;